import { isRowInEntityFilter } from './entityValue';
import { isRowInFundFilter, isRowInSecurityFilter } from './fundSecurityFilter';

// Header row, then one row per transaction. Rows outside the entity/fund/security filters are
// hidden, never dropped, so they still reach the save payload.
export const CashFlowRowConfig = (
  items: any,
  activeEntities: string[] = [],
  activeFundIds: string[] = [],
  activeSecurityIds: string[] = []
) => [
  {
    largeHeader: true,
    ignoreRowCopy: true,
    className: 'division-bottom-only text-right',
    readOnly: true,
  },
  ...(items || []).map((item: any) => ({
    ...item,
    isDeletableRow: !item?.is_virtual,
    isVisible:
      isRowInEntityFilter(item, activeEntities)
      && isRowInFundFilter(item, activeFundIds)
      && isRowInSecurityFilter(item, activeSecurityIds),
  })),
];
